import { render, staticRenderFns } from "./ReservationInput.vue?vue&type=template&id=354706ca"
import script from "./ReservationInput.vue?vue&type=script&lang=js"
export * from "./ReservationInput.vue?vue&type=script&lang=js"
import style0 from "./ReservationInput.vue?vue&type=style&index=0&id=354706ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports